import React from 'react';
import { Divider, LinkListItem } from '../../index';
import './link_list.scss';

export const LinkList = ({
    children,
    className,
    disabled = false,
    list,
    typographyType
}) => {

    const linkListClasses = [
        `bsw-link-list`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <div className={linkListClasses}>
            {children 
                ? children
                : list && list?.length > 0 &&
                    list.map((item, index) => {
                        return (<React.Fragment key={index}>
                            <LinkListItem
                                disabled={disabled}
                                item={item}
                                typographyType={typographyType}
                            />
                            {index !== (list.length - 1) && <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />}
                        </React.Fragment>)
                    })
            }
        </div>
    );
};
